import { useEffect } from "react";
import { useHistory } from "react-router";
// Components

// Constants
// import { TITLE, SUB_TITLE, BUTTON_NAME , BUTTON_LINK, SECOND_BUTTON_NAME, SECOND_BUTTON_LINK, ALL_CARD_ROWS} from "./SalesConstants";
// import { SIGN_UP_TITLE, SIGN_UP_SUB_TITLE, BANNER_LINK, BUTTON_NAME_SIGN_UP } from "./SalesConstants";

// Images
import salesBanner from "../../../assets/img/partnerPortal/sales/Half Wave.svg";
import create from "../../../assets/img/partnerPortal/sales/create.svg";
import save from "../../../assets/img/partnerPortal/sales/save.svg";
import submit from "../../../assets/img/partnerPortal/sales/submit.svg";
import approval from "../../../assets/img/partnerPortal/sales/thumbUp.svg";
import end_user_to_choose from "../../../assets/img/partnerPortal/sales/end_user_to_choose.png";
import step_2_deal_origin from "../../../assets/img/partnerPortal/sales/deal_origin.png";
import step_2_procurement from "../../../assets/img/partnerPortal/sales/procurement_option.png";
import step_2_registration_level from "../../../assets/img/partnerPortal/sales/registration_level.png";
import step_3 from "../../../assets/img/partnerPortal/sales/description_of_project.png";
import step_4 from "../../../assets/img/partnerPortal/sales/stage_of_opp.png";
import step_5 from "../../../assets/img/partnerPortal/sales/partner_contact.png";

// Scss
import "../../../assets/css/partnerPortal/sales.scss";
import "../../../assets/css/partnerPortal/welcome.scss";
import "../../../assets/css/partnerPortal/appDeveloper.scss";
import Title from "../../../components/Title";
import PrimaryButtonBlue from "../../../components/PrimaryButtonBlue";

import Image from "react-bootstrap/Image";

import ContentExplanation from "../../../components/ContentExplanation";

function Sales() {
  let history = useHistory();

  useEffect(() => {
    canYouHaveAccess();
  }, []);

  return (
    <>
      <div>
        <div className="row d-flex mb-3">
          <img
            src={salesBanner}
            className=" shadow-4 imageBannerSales"
            alt="..."
          />
          <div className="boxBannerSales">
            <div className="headerTitle">
              <Title
                classNameText="salesTitle"
                title={"Partner Deal Registration"}
                withoutLine={true}
              />
            </div>
            <div className="subCopy">
              <div className="subCopyLetters mb-3">
                A Partner Deal Registration (PDR) is a form that lets Dynatrace
                know about prospective sales opportunities and establishes
                opportunity parameters, including the Partner Sales Effort and
                corresponding percentage of revenue to be shared.
              </div>
            </div>
            <PrimaryButtonBlue
              text={"View or Create a Partner Deal Registration"}
              className={""}
              classNameOfA={"wid55"}
              link={"https://partners.dynatrace.com/#/deals"}
            />
          </div>
        </div>

        <div>
          <div className="guideList">
            <div className="guideHeaderSection">
              <div className="headerTitle">
                <div className="guideText">Guide to register a deal</div>
              </div>
            </div>
            <div className="cardBoxRow">
              <div className="mb-5 cardBox">
                <Image src={create} width={"19%"} className="cardImage" />
                <div className="cardBoxContent">
                  <div className="cardBoxText">
                    <div className="cardBoxText2">Create PDR</div>
                  </div>
                </div>
              </div>
              <div className="mb-5 cardBox">
                <Image src={save} width={"19%"} className="cardImage" />
                <div className="cardBoxContent">
                  <div className="cardBoxText">
                    <div className="cardBoxText2">Save PDR</div>
                  </div>
                </div>
              </div>
              <div className="mb-5 cardBox">
                <Image src={submit} width={"19%"} className="cardImage" />
                <div className="cardBoxContent">
                  <div className="cardBoxText">
                    <div className="cardBoxText2">Submit PDR</div>
                  </div>
                </div>
              </div>
              <div className="mb-5 cardBox">
                <Image src={approval} width={"19%"} className="cardImage" />
                <div className="cardBoxContent">
                  <div className="cardBoxText">
                    <div className="cardBoxText2">Dynatrace Approval</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="explainProcess">
            <ContentExplanation
              title="1. Input End User info"
              sectionText={
                <div>
                  You can select the customer/prospect related with PDR, by
                  selecting the right one in the dropdown shown in 1. Please
                  confirm the address so that you select the correct entity.
                  <br></br>
                  <br></br>
                  If you don't find your customer/prospect on the dropdown: you
                  can request a new account, by clicking on the “Request New
                  Account”, shown in 2, and then associate it to the PDR you’re
                  creating.
                </div>
              }
              sectionImage={end_user_to_choose}
            />
            <ContentExplanation
              title="2. Engagement Model"
              sectionText={
                <div>
                  <b>Opportunity Name</b>
                  <br></br>
                  Use a name that makes sense for you to identify the
                  opportunity. You should put the end user account name in the
                  deal name to make it easy for you to search the PDR in the
                  future.
                  <br></br>
                  <br></br>
                  <b>Deal Origin Explanation</b>
                  <br></br>
                  Provide clear and consistent information on who started the
                  opportunity (Dynatrace or partner).
                  <br />
                  <br />
                  If this PDR originates from a joint marketing campaign with
                  Dynatrace, please include the campaign code you received. If
                  you don’t have it, please contact your Partner Sales Manager
                  or Partner Marketing Manager.
                </div>
              }
              sectionImage={step_2_deal_origin}
            />
            <ContentExplanation
              title=""
              sectionText={
                <div>
                  <b>Likely procurement option</b>
                  <br></br>
                  Let us know if you prefer to:
                  <br></br>
                  <br></br>
                  <div className="ml-2">
                    ·&nbsp;&nbsp; Resell the licenses to the end customer
                    <br></br>
                    <br></br>
                    ·&nbsp;&nbsp; If you’ll be buying the licenses yourself
                    (MSP) to deliver a service to the end customer
                    <br></br>
                    <br></br>
                    ·&nbsp;&nbsp; Ask Dynatrace to sell the licenses to the end
                    customer while you receive a referral fee
                  </div>
                </div>
              }
              sectionImage={step_2_procurement}
            />
            <ContentExplanation
              title=""
              sectionText={
                <div>
                  <b>Registration Level</b>
                  <br></br>
                  Let us know how you’ll work on this opportunity:
                  <br></br>
                  <br></br>
                  <div className="ml-2">
                    ·&nbsp;&nbsp; <b>DRIVER</b> (Significant role) You have
                    introduced Dynatrace to a new, qualified sales opportunity
                    and agree to work with us closely to win the business
                    throughout the sales cycle; OR, you are playing a
                    significant, driving role in a known opportunity.
                    <br></br>
                    <br></br>
                    ·&nbsp;&nbsp; <b>LIMITED</b> (Influence in limited portion
                    of sales cycle) You’ll be involved in the opportunity
                    without playing a significant role in the whole sales cycle.
                    <br></br>
                    <br></br>
                    ·&nbsp;&nbsp; <b>PAPER</b> (Procurement Vehicle) You’ll
                    deliver the sale through an existing procurement vehicle
                    after Dynatrace is selected, and may also provide an
                    administrative expediting role to secure the order faster.
                  </div>
                </div>
              }
              sectionImage={step_2_registration_level}
            />
            <ContentExplanation
              title="3. Opportunity qualification"
              sectionText={
                <div>
                  Provide all known details about the client project so
                  Dynatrace has clear and consistent information to validate the
                  opportunity.
                </div>
              }
              sectionImage={step_3}
            />
            <ContentExplanation
              title="4. Stage of Opportunity"
              sectionText={
                <div>
                  Select all options related to the steps that you have already
                  taken with your customer.
                </div>
              }
              sectionImage={step_4}
            />
            <ContentExplanation
              title="5. Input Partner info"
              sectionText={
                <div>
                  Select the name of the person from your company who will be in
                  charge of the opportunity. The person creating the PDR will be
                  chosen by default.
                </div>
              }
              sectionImage={step_5}
            />

            <div className="faqTitle">
              <div className="faqHeader">
                <div className="faqTitleText">Rules of Engagement</div>
              </div>
            </div>
            <ul>
              <li>
                {" "}
                <div className="faqBodyText">
                  PDRs are valid for 9 months from the approval date, and can be
                  extended by mutual consent. In the event there is no reported
                  or observed opportunity development during the initial 30 days
                  following the PDR approval, Dynatrace reserves the right to
                  restart the PDR approval process.
                </div>
              </li>
              <li>
                {" "}
                <div className="faqBodyText">
                  Dynatrace reserves the right to modify deal registration
                  parameters in the event that partner fails to meet the agreed
                  expectations, but Dynatrace will attempt to communicate and
                  resolve problems with partner in advance of any such
                  modifications.
                </div>
              </li>
              <li>
                <div className="faqBodyText">
                  Sales activities are coordinated between Dynatrace and
                  Partner, including any discussions related to pricing or
                  meetings.
                </div>
              </li>
            </ul>
            {/* <div className="faqBodyText">
              ·&nbsp;&nbsp;PDRs are valid for 9 months from the approval date,
              and can be extended by mutual consent. In the event there is no
              reported or observed opportunity development during the initial 30
              days following the PDR approval, Dynatrace reserves the right to
              restart the PDR approval process.
            </div>

            <div className="faqBodyText">
              ·&nbsp;&nbsp; Dynatrace reserves the right to modify deal
              registration parameters in the event that partner fails to meet
              the agreed expectations, but Dynatrace will attempt to communicate
              and resolve problems with partner in advance of any such
              modifications.
            </div>

            <div className="faqBodyText">
              ·&nbsp;&nbsp;Sales activities are coordinated between Dynatrace
              and Partner, including any discussions related to pricing or
              meetings.
            </div> */}

            <div className="rulesTableFrame">
              <div className="rulesTableExplanation">
                <strong>Applicable Resale Margin and MSP Discount.</strong> The
                applicable Resale Margin or MSP Discount will be confirmed by
                Partner and Dynatrace in a PDR or otherwise reflected in a quote
                provided by Dynatrace, prior to a proposal being provided by
                Partner to a prospective End User or Client. Subject to rules
                defined below, the applicable Resale Margin will be based on
                sales effort and Tier; and the applicable MSP Discount will be
                based on Tier, as follows:
              </div>
              <div className="rulesTableMenu">
                {/* <div className="rulesTableMenuDetail">
                  <div className="rulesTableMenuLeftSide"></div>
                  <div className="rulesTableMenuRightSideTitle">
                    <div className="programTierTitle">PROGRAM TIER</div>
                    <div className="tableDivider"></div>
                  </div>
                </div> */}
                <div className="rulesTableMenuDetail">
                  <div className="rulesTableMenuLeftSide">Program Tier</div>
                  <div className="rulesTableMenuRightSide">
                    <div className="rulesTableMenuRightContent">
                      <div className="rulesTableMenuRightText verticalWritten">
                        <div className="wrapText">
                          Paper <sub>1</sub>
                        </div>
                      </div>
                      <div className="rulesTableMenuRightText verticalWritten">
                        <div className="wrapText">
                          Partner Influenced <sub>1</sub>
                          <p>(Dynatrace Originated)</p>
                        </div>
                      </div>
                      <div className="rulesTableMenuRightText verticalWritten">
                        <div className="wrapText">
                          Partner Originated <sub>1</sub>
                        </div>
                      </div>
                      <div className="rulesTableMenuRightText verticalWritten">
                        MSP Discount based on Tier
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableDivider"></div>
              </div>
              <div className="rulesTableMenu">
                <div className="rulesTableMenuDetail">
                  <div className="rulesTableMenuLeftSide fontSize18">
                    <div className="activityDetails2">Fulfilment</div>
                  </div>
                  <div className="rulesTableMenuRightSide">
                    <div className="rulesTableMenuRightContent">
                      <div className="rulesTableMenuRightText fontWeight400">
                        3%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        3%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        3%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        Not Applicable
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableDivider"></div>
              </div>
              <div className="rulesTableMenu">
                <div className="rulesTableMenuDetail">
                  <div className="rulesTableLeftOptions">
                    <div className="activityDetails2">Ignite</div>
                  </div>
                  <div className="rulesTableMenuRightSide">
                    <div className="rulesTableMenuRightContent">
                      <div className="rulesTableMenuRightText fontWeight400">
                        3%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        3%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        10%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        Not Applicable
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableDivider"></div>
              </div>
              <div className="rulesTableMenu">
                <div className="rulesTableMenuDetail">
                  <div className="rulesTableLeftOptions">
                    <div className="activityDetails2">Authorized</div>
                  </div>
                  <div className="rulesTableMenuRightSide">
                    <div className="rulesTableMenuRightContent">
                      <div className="rulesTableMenuRightText fontWeight400">
                        3%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        7%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        15%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        15%
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableDivider"></div>
              </div>
              <div className="rulesTableMenu">
                <div className="rulesTableMenuDetail">
                  <div className="rulesTableLeftOptions">
                    <div className="activityDetails2">Advanced</div>
                  </div>
                  <div className="rulesTableMenuRightSide">
                    <div className="rulesTableMenuRightContent">
                      <div className="rulesTableMenuRightText fontWeight400">
                        3%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        10%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        20%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        20%
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableDivider"></div>
              </div>
              <div className="rulesTableMenu">
                <div className="rulesTableMenuDetail">
                  <div className="rulesTableLeftOptions">
                    <div className="activityDetails2">Premier</div>
                  </div>
                  <div className="rulesTableMenuRightSide">
                    <div className="rulesTableMenuRightContent">
                      <div className="rulesTableMenuRightText fontWeight400">
                        5%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        12%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        25%
                      </div>
                      <div className="rulesTableMenuRightText fontWeight400">
                        25%
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tableDivider"></div>
              </div>

              <div className="finalNotes">
                <sup>1</sup> Reseller Resale Margin (%) based on Sales Effort
                and Tier &nbsp;&nbsp;
              </div>
              <div className="rulesTableExplanation mt-4">
                <strong>
                  Calculating Resale Margin for Resale Transactions.
                </strong>{" "}
                New Sales/Growth. 100% of the Resale Margin percentage is
                multiplied by Bookable Gross Revenue of “New Sales/Growth” which
                includes, as applicable: (1) the Initial Term, (2) any on-demand
                consumption, and (3) any other growth sale (excluding for
                clarity, the portion that constitutes the Renewal).
              </div>
            </div>

            <div className="faqTitle">
              <div className="faqHeader">
                <div className="faqTitleText">FAQ</div>
              </div>
            </div>

            <div className="faqBodyRow">
              <div className="faqBodyItem width66">
                <div className="faqHeaderPlusText">
                  <div className="faqBodyHeader">
                    I have a Referral PDR in place, when will I get paid?{" "}
                  </div>
                  <div className="faqBodyText">
                    After the customer pays Dynatrace, we will send you an
                    email, with all the details you need to request the due
                    payment from Dynatrace. Please note that referrals are
                    applicable to the deal in question, and not to consequent
                    renewals. If you have specific doubts, please feel free to
                    contact the Partner Operations team.
                    partneroperations@dynatrace.com
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

  function canYouHaveAccess() {
    try {
      if (
        process.env.REACT_APP_PROTECT_PAGE === "true" &&
        window.top?.location.host !== process.env.REACT_APP_ALLOW_API
      ) {
        console.log("You shall not pass");
        history.push("/not-found");
      }
    } catch (err) {}
  }
}

export default Sales;
